import { UPDATE_IS_BRANDED } from '../actions';

export const isBranded = (state = false, action) => {
  switch (action.type) {
    case UPDATE_IS_BRANDED: {
      return action.isBranded;
    }
    default:
      return state;
  }
};
